package game.controller

import com.soywiz.korge.input.Input
import game.Game

class ScriptController(private val script: List<(Game) -> GameController>) : GameController() {

    private var step = 0

    override fun onTick(game: Game, input: Input) {
        if (step == script.size) {
            game.controller = PlayController()
        } else {
            val stepController = script[step].invoke(game)

            step++
        }

    }
}